// extracted by mini-css-extract-plugin
export default {"bottomLine":"logo_bottomLine__4IyFf","bottomLineLight":"logo_bottomLineLight__-sDDm","textLogo":"logo_textLogo__e-Oj6","whiteLogo":"logo_whiteLogo__bcQb9"};